import React, { useEffect, useState } from 'react';
import { signInWithEmailAndPassword, signInWithPopup } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { auth, db, googleProvider } from '../../firebase';
import { googleLogo } from '../../photos';
import { useTranslatedText } from '../i18n/useTranslatedText.js';
import { formatAuthErrorMessage } from '../../utils/authErrorMessage.js';
import './Auth.css';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const loadingText = useTranslatedText('Yükleniyor...');
  const titleText = useTranslatedText('Giriş Yap');
  const googleLoginText = useTranslatedText('Gmail ile Giriş Yap');
  const noAccountText = useTranslatedText('Hesabınız yok mu?');
  const signUpText = useTranslatedText('Hesap Oluştur');
  const emailPlaceholder = useTranslatedText('E-posta');
  const passwordPlaceholder = useTranslatedText('Şifre');
  const serviceUnavailableText = useTranslatedText('Kimlik doğrulama hizmeti geçici olarak kullanılamıyor. Lütfen daha sonra tekrar deneyin.');
  const rateLimitedText = useTranslatedText('Çok fazla deneme yapıldı. Lütfen daha sonra tekrar deneyin.');
  const authFailedText = useTranslatedText('İşlem tamamlanamadı. Lütfen bilgilerinizi kontrol edip tekrar deneyin.');

  const authErrorMessages = {
    serviceUnavailable: serviceUnavailableText,
    rateLimited: rateLimitedText,
    fallback: authFailedText,
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setTimeout(() => navigate('/'), 500);
      } else {
        setLoading(false);
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/');
    } catch (err) {
      setError(formatAuthErrorMessage(err, authErrorMessages));
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      const userDocRef = doc(db, 'users', user.uid);
      const userDocSnap = await getDoc(userDocRef);

      if (!userDocSnap.exists()) {
        await setDoc(userDocRef, {
          email: user.email,
          createdAt: new Date().getTime(),
          isAdmin: false,
          emailVerified: true,
        });
        navigate('/google-kayıt-tamamla');
      } else if (!userDocSnap.data().username || !userDocSnap.data().age) {
        navigate('/google-kayıt-tamamla');
      } else {
        navigate('/');
      }
    } catch (err) {
      setError(formatAuthErrorMessage(err, authErrorMessages));
    }
  };

  if (loading) return <div>{loadingText}</div>;

  return (
    <div className="auth-container">
      <h2>{titleText}</h2>
      {error && <p>{error}</p>}
      <button className="google-signin" onClick={handleGoogleLogin}>
        <img src={googleLogo} alt="Google logo" className="google-logo" />
        <span>{googleLoginText}</span>
      </button>
      <form onSubmit={handleLogin}>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={emailPlaceholder} required />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder={passwordPlaceholder}
          required
        />
        <button type="submit" className="Confirm">{titleText}</button>
      </form>
      <div className="switch-auth">
        <p>{noAccountText}<a href="/hesap-oluştur">{signUpText}</a></p>
      </div>
    </div>
  );
};

export default Login;
